import { GetState, SetState } from 'zustand';

export interface IInnerWidthSlice {
  currentWidth: number;
  isBigScreen: boolean;
  setIsBigScreen: (isBigScreen: boolean) => void;
  isMobileScreen: boolean;
  setIsMobileScreen: (isMobileScreen: boolean) => void;
  getIsBigScreen: () => boolean;
  setCurrentWidth: (n: number) => void;
  getCurrentWidth: () => number;
}

const createInnerWidthSlice = (set: SetState<IInnerWidthSlice>, get: GetState<IInnerWidthSlice>) => ({
  currentWidth: 1440,
  isBigScreen: true,
  setIsBigScreen: (isBigScreen: boolean) => {
    set({ isBigScreen });
  },
  getIsBigScreen: () => get().isBigScreen,
  isMobileScreen: false,
  setIsMobileScreen: (isMobileScreen: boolean) => {
    set({ isMobileScreen });
  },
  setCurrentWidth: (n: number) => {
    set({ currentWidth: n });
  },
  getCurrentWidth: () => get().currentWidth,
});

export default createInnerWidthSlice;
